<div class="custom-mold-container">
  <mic-breadcrumb id="custommold-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('productDataText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('customMoldText') }}"></mic-breadcrumb-link>
  </mic-breadcrumb>

  <div class="custom-mold-header">
    <h2 class="page-title custom-mold-heading" id="custommold-heading">{{ translationService.translate('customMoldText') }}</h2>
    <div class="action-bar">
      <button
        id="reset-filters"
        type="button"
        mat-flat-button
        color="accent"
        class="btn-clear custom-mold-action-button"
        (click)="resetFilters()"
      >
        <mat-icon>refresh</mat-icon>
        {{ translationService.translate('clearSelectionText') }}
      </button>
      <span
        [matTooltip]="
          productSaveDisabled
            ? this.translationService.translate('comingSoonText')
            : !saveEnabled
            ? this.translationService.translate('userCannotSaveText')
            : !isModified
            ? this.translationService.translate('noModifiedText')
            : null
        "
        matTooltipPosition="above"
      >
        <button
          id="save"
          type="button"
          mat-flat-button
          color="primary"
          class="btn-primary custom-mold-action-button"
          (click)="save()"
          [disabled]="!saveEnabled || !isModified"
        >
          <mat-icon>save</mat-icon>
          {{ translationService.translate('saveLinkText') }}
        </button>
      </span>
      <button
        id="export-button-top"
        mat-flat-button
        color="primary"
        class="btn-export custom-mold-action-button"
        (click)="openExportModal()"
      >
        <mat-icon>download</mat-icon>
        {{ translationService.translate('exportButtonText') }}
      </button>
    </div>
  </div>

  <form [formGroup]="formGroup">
    <mat-card class="custom-mold-filter-card">
      <div class="grid-container">
        <!-- Row 1: Tread, Casing Make, Casing Series, Casing Size -->
        <mic-dropdown-search
          micDropdownAccessibility
          id="treads"
          formControlName="treads"
          [data]="treads"
          [widthConfig]="{ width: '100%' }"
          [style.width]="filterDropdownWidth"
          placeholder="{{ translationService.translate('treadSearchText') }}"
          label="{{ translationService.translate('treadText') }}"
          searchPlaceholder="Search"
          subscriptSizing="dynamic"
          [multiple]="true"
        >
        </mic-dropdown-search>

        <mic-dropdown-search
          micDropdownAccessibility
          id="casingMakes"
          formControlName="casingMakes"
          [data]="casingMakes"
          [widthConfig]="{ width: '100%' }"
          [style.width]="filterDropdownWidth"
          placeholder="{{ translationService.translate('selectCasingMakeText') }}"
          label="{{ translationService.translate('casingMakesText') }}"
          searchPlaceholder="Search"
          subscriptSizing="dynamic"
          [multiple]="true"
        >
        </mic-dropdown-search>

        <mic-dropdown-search
          micDropdownAccessibility
          id="casingSeries"
          formControlName="casingSeries"
          [data]="casingSeries"
          [widthConfig]="{ width: '100%' }"
          [style.width]="filterDropdownWidth"
          placeholder="{{ translationService.translate('selectSeriesText') }}"
          label="{{ translationService.translate('casingSeriesText') }}"
          searchPlaceholder="Search"
          subscriptSizing="dynamic"
          [multiple]="true"
        >
        </mic-dropdown-search>

        <mic-dropdown-search
          micDropdownAccessibility
          id="casingSizes"
          formControlName="casingSizes"
          [data]="casingSizes"
          [widthConfig]="{ width: '100%' }"
          [style.width]="filterDropdownWidth"
          placeholder="{{ translationService.translate('selectCasingSizeText') }}"
          label="{{ translationService.translate('casingSizeText') }}"
          searchPlaceholder="Search"
          subscriptSizing="dynamic"
          [multiple]="true"
        >
        </mic-dropdown-search>

        <!-- Row 2: Tread Brand, Application, Axle, Mold Contour -->
        <mic-dropdown-search
          micDropdownAccessibility
          id="treadBrands"
          formControlName="treadBrands"
          [data]="treadBrands"
          [widthConfig]="{ width: '100%' }"
          [style.width]="filterDropdownWidth"
          placeholder="{{ translationService.translate('selectTreadBrandText') }}"
          label="{{ translationService.translate('treadBrandText') }}"
          searchPlaceholder="Search"
          subscriptSizing="dynamic"
          [multiple]="true"
        >
        </mic-dropdown-search>

        <mic-dropdown-search
          micDropdownAccessibility
          id="applications"
          formControlName="applications"
          [data]="applications"
          [widthConfig]="{ width: '100%' }"
          [style.width]="filterDropdownWidth"
          placeholder="{{ translationService.translate('selectApplicationText') }}"
          label="{{ translationService.translate('applicationText') }}"
          searchPlaceholder="Search"
          subscriptSizing="dynamic"
          [multiple]="true"
        >
        </mic-dropdown-search>

        <mic-dropdown-search
          micDropdownAccessibility
          id="axles"
          formControlName="axles"
          [data]="axles"
          [widthConfig]="{ width: '100%' }"
          [style.width]="filterDropdownWidth"
          placeholder="{{ translationService.translate('selectAxleText') }}"
          label="{{ translationService.translate('axleText') }}"
          searchPlaceholder="Search"
          subscriptSizing="dynamic"
          [multiple]="true"
        >
        </mic-dropdown-search>

        <mic-dropdown-search
          micDropdownAccessibility
          id="moldContours"
          formControlName="moldContours"
          [data]="moldContours"
          [widthConfig]="{ width: '100%' }"
          [style.width]="filterDropdownWidth"
          placeholder="{{ translationService.translate('selectMoldContoursText') }}"
          label="{{ translationService.translate('moldContourText') }}"
          searchPlaceholder="Search"
          subscriptSizing="dynamic"
          [multiple]="true"
        >
        </mic-dropdown-search>
      </div>
    </mat-card>
  </form>
  @if (isExporting) {
  <mic-spinner id="custom-mold-export-spinner" ariaLabel="In Progress" color="primary" [strokeWidth]="5"></mic-spinner>
  }

  <div id="custom-mold-table" class="cam-table table-container">
    <div class="table-wrapper">
      <div class="table-inner">
        <mic-table class="table-stripped" [config]="tableConfig" [fetcher]="fetcher">
          <ng-container *micTableNoData>
            <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"></mic-empty-state>
          </ng-container>
          <ng-container *micTableColumnSelector>
            <button mat-flat-button [matMenuTriggerFor]="colMenu" (click)="$event.stopPropagation()">
              <mat-icon>view_column</mat-icon> {{ translationService.translate('columnsButtonText') }}
            </button>
            <mat-menu #colMenu="matMenu">
              <div
                class="column-menu-content column-menu-list"
                cdkDropList
                [cdkDropListData]="columnOrder"
                (cdkDropListDropped)="onColumnDrop($event)"
              >
                @for (key of columnOrder; track key) {
                <div class="column-menu-item" cdkDrag>
                  <mat-icon class="column-drag-handle" cdkDragHandle aria-hidden="true">drag_indicator</mat-icon>
                  <mat-checkbox
                    [checked]="columnVisibility[key]"
                    (click)="$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()"
                    (change)="toggleColumn(key)"
                    >{{ columnNames[key] || key }}</mat-checkbox
                  >
                </div>
                }
              </div>
            </mat-menu>
          </ng-container>
          <ng-container *micCellTemplate="let item; name: 'dealerTreadCompoundDropdown'">
            <mic-dropdown-search
              micDropdownAccessibility
              emptyPlaceholder="No data found"
              subscriptSizing="dynamic"
              [data]="dropDownLists"
              [widthConfig]="dropdownWidthConfig"
              [formControl]="getControl(item, 'dealerTreadCompound')"
            >
            </mic-dropdown-search>
          </ng-container>

          <ng-container *micCellTemplate="let item; name: 'dealerCTCDropdown'">
            <mic-dropdown-search
              micDropdownAccessibility
              emptyPlaceholder="No data found"
              subscriptSizing="dynamic"
              [widthConfig]="dropdownWidthConfig"
              [data]="dropDownLists"
              [formControl]="getControl(item, 'dealerCTC')"
            >
            </mic-dropdown-search>
          </ng-container>
        </mic-table>
      </div>
    </div>
  </div>

  <mic-modal class="modalC" #discardConfirmation (result)="onDiscardModalClosed($event)"></mic-modal>
  <ng-template #discardContent>{{ translationService.translate('unSaveChangesText') }}</ng-template>
</div>
